import { Injectable } from '@angular/core'
import { DesktopPlatform } from '@ftr/contracts/api/desktop'
import { ConfigurationService } from '~app/services/configuration/configuration.service'
import { WindowRefService } from '~app/services/window/window-ref.service'

@Injectable()
export class DesktopDownloadUrlService {
  constructor(
    private readonly windowRefService: WindowRefService,
    private readonly configurationService: ConfigurationService,
  ) {}

  getDownloadUrl(): string {
    return `${this.configurationService.desktopAppUrl}?platform=${
      this.windowRefService.isMac() ? DesktopPlatform.MacOS : DesktopPlatform.Windows
    }`
  }

  openDownloadUrl(): void {
    this.windowRefService.open(this.getDownloadUrl(), '_blank')
  }
}
